import { Injectable } from '@angular/core';
import { StorageError } from 'app/core/errors/storage-error';
import { ODataApiDataService } from 'app/core/storage/odata-api-data.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '~env';
import { Municipality } from './municipalities.model';

const API_URL = environment.projectionQueryApi;

@Injectable({
  providedIn: 'root',
})
export class MunicipalityQueryService {
  constructor(private dataService: ODataApiDataService<Municipality>) { }

  getMany(): Observable<Municipality[]> {
    return this.dataService
      .odataList(`${API_URL}/municipalities?$orderby=Name`)
      .pipe(
        map(res => {
          return res.map(item => {
            return this.parseMunicipalityObject(item);
          });
        }),
      )
      .pipe(
        catchError(error => {
          return throwError(this.buildError(error, '[Municipality] getMany'));
        }),
      );
  }

  getOneById(municipalityId: string): Observable<Municipality> {
    return this.dataService
      .odataGetById(`${API_URL}/municipalities?$filter=Id eq '${municipalityId}'`)
      .pipe(
        map(res => {
          return this.parseMunicipalityObject(res);
        }),
      )
      .pipe(
        catchError(error => {
          return throwError(this.buildError(error, '[Municipality] getOneById'));
        }),
      );
  }

  getMunicitalityByName(name: string): Observable<Municipality> {
    return this.dataService
      .odataList(`${API_URL}/municipalities?$filter=Name eq '${name}'`)
      .pipe(
        map(res => {
          return !!res && !!res[0] ? this.parseMunicipalityObject(res[0]) : null;
        }),
      )
      .pipe(
        catchError(error => {
          return throwError(this.buildError(error, '[Municipality] getOneById'));
        }),
      );
  }

  parseMunicipalityObject(item: any): Municipality {
    return {
      id: item.Id,
      name: item.Name,
      code: item.Code,
      countryIsoCode2: item.CountryIsoCode2,
      countryName: item.CountryName,
      provinceIsoCode: item.ProvinceIsoCode,
      provinceName: item.ProvinceName,
      electoralRegionCode: item.ElectoralRegionCode,
      administrativeRegionCode: item.AdministrativeRegionCode,
      isActive: item.IsActive,
    } as Municipality;
  }

  buildError(error: any, callName: string): StorageError {
    const storageError = new StorageError();
    storageError.message = `FirebaseError [${callName}]: Error code => ${error.code} with message ${error.message}`;
    storageError.code = error.code;
    return storageError;
  }
}
